import { render, staticRenderFns } from "./BranchOrdered.vue?vue&type=template&id=5767c2fa&"
import script from "./BranchOrdered.vue?vue&type=script&lang=js&"
export * from "./BranchOrdered.vue?vue&type=script&lang=js&"
import style0 from "./BranchOrdered.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports